import type { PropertyView } from './types.js';

const DAY = 86_400_000;

type Aged = Pick<
  PropertyView,
  'status' | 'createdAt' | 'updatedAt' | 'lastConfirmedAt' | 'lastEnquiryAt'
>;

/** Whole days between an instant and now, never negative. */
export function daysAgo(iso: string, now: number): number {
  return Math.max(0, Math.floor((now - new Date(iso).getTime()) / DAY));
}

/** An available flat that is at least a week old and has had no enquiry in 7 days. */
export function isQuiet(p: Aged, now: number): boolean {
  if (p.status !== 'available') return false;
  if (now - new Date(p.createdAt).getTime() < 7 * DAY) return false;
  return p.lastEnquiryAt == null || now - new Date(p.lastEnquiryAt).getTime() >= 7 * DAY;
}

/** An available flat neither edited nor confirmed as still available for 15 days. */
export function isStale(p: Aged, now: number): boolean {
  if (p.status !== 'available') return false;
  const touched = Math.max(
    new Date(p.updatedAt).getTime(),
    p.lastConfirmedAt === null ? 0 : new Date(p.lastConfirmedAt).getTime(),
  );
  return now - touched >= 15 * DAY;
}
